<template>
  <AlertModal />
  <ConfirmModal />
</template>

<script>
import AlertModal from "./AlertModal.vue";
import ConfirmModal from "./ConfirmModal.vue";

export default {
  components: { AlertModal, ConfirmModal },
};
</script>
